import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import AddUserDialog from './AddUserDialog';
import queries from '../../graphql/queries';
import mutations from '../../graphql/mutations';
import OverlayController from '../overlay/OverlayController';
import { compose } from 'react-apollo';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import userContext from '../../services/userContext';
import './ACLList.css';


class ACLList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            userACLLists: null
        };
    }

    didClickAddACL() {
        OverlayController.showOverlay({
            component: <AddUserDialog project={this.props.project} />
        });
    }

    didClickChangeACL(acl) {

    }

    didClickRemoveACL(acl) {
        OverlayController.showActivityIndicator();
        this.props.deleteACL(acl.id)
            .then(({data}) => {
                console.log('deleteACL response data', data);
                OverlayController.hideActivityIndicator();
            })
            .catch((error) => {
                console.log('there was an error sending the query', error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

/*
    componentWillReceiveProps(nextProps) {
        if (nextProps.data.aclList) {
            console.log(nextProps.data.aclList);
            let aclList = nextProps.data.aclList;
            let userMap = {};
            let users = [];
            aclList.forEach(_acl => {
                let acl = {
                    id: _acl.id,
                    role: _acl.role,
                    objectId: _acl.objectId,
                    objectType: _acl.objectType,
                    parentObjectId: _acl.parentObjectId,
                    user: {
                        id: _acl.user.id,
                        email: _acl.user.email
                    }
                };
                let userId = acl.user.id;
                let userACLs;
                if (!(userId in userMap)) {
                    userACLs = {
                        user: acl.user,
                        projectACLsMap: {},
                        boardACLsMap: {},
                        projectACLs: [],
                        boardACLs: [],
                        queueACLs: []
                    };
                    userMap[userId] = userACLs;
                    users.push(userACLs);
                } else {
                    userACLs = userMap[userId];
                }
                switch (acl.objectType) {
                    case "Project":
                        acl.boardACLs = [];
                        userACLs.projectACLsMap[acl.objectId] = acl;
                        userACLs.projectACLs.push(acl);
                        break;
                    case "Board":
                        acl.queueACLs = [];
                        userACLs.boardACLsMap[acl.objectId] = acl;
                        userACLs.boardACLs.push(acl);
                        break;
                    case "Queue":
                        userACLs.queueACLs.push(acl);
                        break;
                }
            });
            let userACLLists = users.map(userACLs => {
                let aclList = [];
                userACLs.queueACLs.forEach(queueACL => {
                    userACLs.boardACLsMap[queueACL.parentObjectId].queueACLs.push(queueACL);
                });
                userACLs.boardACLs.forEach(boardACL => {
                    userACLs.projectACLsMap[boardACL.parentObjectId].boardACLs.push(boardACL);
                });
                userACLs.projectACLs.forEach(projectACL => {
                    aclList.push(projectACL);
                    projectACL.boardACLs.forEach(boardACL => {
                        aclList.push(boardACL);
                        boardACL.queueACLs.forEach(queueACL => {
                            aclList.push(queueACL);
                        });
                    });
                });
                return {
                    user: userACLs.user,
                    aclList: aclList
                };
            });
            this.setState({
                userACLLists: userACLLists
            });
        }
    }
*/

    render() {
        let currentUserId = userContext.getCurrentUser().id;
        let aclList = this.props.data.aclList;
        console.log("currentUserId", userContext.getCurrentUser(), aclList);
        return (
            <div>
                {aclList &&
                <Table selectable={false} className="aclTable" wrapperStyle={{marginBottom: 20}}>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn>User email</TableHeaderColumn>
                            <TableHeaderColumn>User role</TableHeaderColumn>
                            {/*<TableHeaderColumn/>*/}
                            <TableHeaderColumn/>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {aclList.map(acl => (
                            <TableRow key={acl.id}>
                                <TableRowColumn>{acl.user.email}</TableRowColumn>
                                <TableRowColumn className="aclRole"><span className="acl-role">{acl.role}</span></TableRowColumn>
{/*
                                <TableRowColumn>
                                    {currentUserId !== acl.user.id &&
                                    <FlatButton className="change-acl-button" label="Change" primary={true} labelStyle={{textTransform: "none"}} onTouchTap={() => this.didClickChangeACL(acl)}/>}
                                </TableRowColumn>
*/}
                                <TableRowColumn>
                                    {currentUserId !== acl.user.id &&
                                    <FlatButton className="remove-acl-button" label="Remove" secondary={true} labelStyle={{textTransform: "none"}} onTouchTap={() => this.didClickRemoveACL(acl)}/>
                                    }
                                </TableRowColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                }
                <RaisedButton style={{height: 36, lineHeight: "36px"}} label="Add User" primary={true} labelStyle={{textTransform: "none"}} onTouchTap={() => this.didClickAddACL()}/>
            </div>
        );
    }

}


export default compose(
    queries.aclListQueryHoc,
    mutations.deleteACLMutationHoc
)(ACLList);



// WEBPACK FOOTER //
// ./src/components/projectSettings/ACLList.js